import {Component} from '@angular/core';
import {UserAppState} from '../../store/user/reducers/user.reducer';
import {Store} from '@ngrx/store';
import {selectUser, selectUserId} from '../../store/user/selectors/user.selectors';
import {Route} from '../../enum/route';
import {take} from 'rxjs';
import {Router} from '@angular/router';
import {UserService} from '../../services/user/user.service';

@Component({
    selector: 'app-user-info',
    templateUrl: './user-info.component.html',
    styleUrls: ['./user-info.component.scss'],
    standalone: false
})
export class UserInfoComponent {

  Route = Route;

  user$ = this.userStore.select(selectUser);

  userId$ = this.userStore.select(selectUserId);

  constructor(
      private readonly userStore: Store<UserAppState>,
      public userService: UserService,
      private readonly router: Router,
  ) {
  }

  navigateToUserProfile() {
    this.userId$.pipe(take(1)).subscribe(
      id => this.router.navigate([Route.USER_PAGE, id])
    );
  }
}
